import React, { useCallback, memo } from "react"
import Dialog from "@material-ui/core/Dialog"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import MuiDialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { deleteParticipantRequest } from "@/redux/actions/participantAction"
import { useDispatch, useSelector } from "react-redux"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import { useParams } from "react-router-dom"

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(5),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "#ffffff",
        backgroundColor: theme.palette.primary.main,
        width: "28px",
        height: "28px",
        "&:hover": {
            backgroundColor: theme.palette.primary.secondary,
        },
    },
})

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    )
})

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(0),
    },
}))(MuiDialogContent)

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        zIndex: "1",
    },
    contentWrapper: {
        padding: theme.spacing(0, 3),
        paddingBottom: theme.spacing(3),
        margin: "0 auto",
        maxWidth: "650px",
        textAlign: "center",
        "&>p": {
            marginBottom: theme.spacing(2),
        },
    },
    contentTitle: {
        marginBottom: theme.spacing(4),
    },
}))

const ModalDelete = memo((props) => {
    const { modalDeleteShow, handleClose, selectedParticipantDetail, targetParticipantFromNoRoleTable } = props
    const classes = useStyles()
    const dispatch = useDispatch()
    const { messagePopup, successStatus, message } = useSelector((state) => state.participantReducer)
    const requestSnackbarValue = useHandleRequestSnackbar(messagePopup)
    const handleCancel = () => {
        handleClose()
    }
    const projectFromParam = useParams().projectId

    const handleConfirm = useCallback(() => {
        const selectedParticipantDetailProjectId = selectedParticipantDetail ? selectedParticipantDetail.projectId : null
        const projectId = selectedParticipantDetailProjectId || projectFromParam
        if (targetParticipantFromNoRoleTable) {
            const { participantId } = targetParticipantFromNoRoleTable
            dispatch(deleteParticipantRequest({ participantId, noRoleSet: true, projectId }))
        } else if (selectedParticipantDetail.participantId) {
            const { participantId } = selectedParticipantDetail
            if (!selectedParticipantDetail.roleId) {
                dispatch(deleteParticipantRequest({ participantId, noRoleSet: true, projectId }))
            } else if (selectedParticipantDetail.roleId) {
                dispatch(deleteParticipantRequest({ participantId, noRoleSet: false, projectId }))
            }
        }
        handleClose()
    }, [targetParticipantFromNoRoleTable, selectedParticipantDetail])
    return (
        <>
            <Dialog disableScrollLock aria-labelledby="delete-participant" open={modalDeleteShow} maxWidth="md" fullWidth>
                <DialogTitle className={classes.closeButton} id="delete-participant" onClose={handleClose} />
                <DialogContent className={classes.dialogContent}>
                    <Box className={classes.contentWrapper}>
                        <Typography variant="h6" component="h2" className={classes.contentTitle} color="textPrimary">
                            Delete Participant?
                        </Typography>
                        <Typography component="p">Are you sure you want to delete?</Typography>
                        <Typography component="p">Click Delete to confirm. This action cannot be undone.</Typography>
                        <Typography component="p">Participant will be informed of their removal from this project via email.</Typography>
                        <Box className={classes.buttonWrapper} m={4} display="flex" justifyContent="center" alignItems="center">
                            <Button variant="outlined" color="primary" onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Box>&nbsp;&nbsp;</Box>
                            <Button variant="contained" color="primary" onClick={handleConfirm}>
                                Delete
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <RequestSnackbar
                status={successStatus}
                message={message}
                snackbarOpen={requestSnackbarValue.snackbarOpen}
                handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
            />
        </>
    )
})

export default ModalDelete
